import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import { DataFormat } from "imports/Utils";
import { GeneralStaffelItemFragment } from "__generated__/view/staffels/graphql/staffel.fragments.generated";

const WaterLevelStaffelItemsTable = ({
	content,
	contentLoading,
}: {
	content: GeneralStaffelItemFragment[];
	contentLoading?: boolean;
}) => (
	<Table
		id="waterLevelStaffelTable"
		content={content}
		contentLoading={contentLoading}
		columns={[ {
			id: "startWaterLevelCm",
			title: intl.formatMessage({ id: "WATERLEVEL_START_HEIGHT" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.simpleUnit("startWaterLevelCm" in row ? row.startWaterLevelCm : 0, DataFormat.UNITS.CENTIMETER),
		}, {
			id: "endWaterLevelCm",
			title: intl.formatMessage({ id: "WATERLEVEL_END_HEIGHT" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.simpleUnit("endWaterLevelCm" in row ? row.endWaterLevelCm : 0, DataFormat.UNITS.CENTIMETER),
		}, {
			id: "surcharge",
			title: intl.formatMessage({ id: "GASOLINE_STAFFEL_SURCHARGE" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.percentage("surcharge" in row ? row.surcharge : undefined),
		} ]}
		disableFooter />
);

export default WaterLevelStaffelItemsTable;
